// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
#questionResultDialog .question-result-content{
    padding:16px;
}
.text-bold{
    font-weight: bold;
}
.pre-test-group{
    background-color:#ffddbc;
}
.post-test-group{
    background-color:#f5ffbc;
}

#order-by-aggregate-view .ag-ltr .ag-cell.user-cell{
    line-height:32px;
}

.ag-header-cell.text-right-align .ag-header-cell-label, .ag-header-group-cell.text-right-align .ag-header-group-cell-label {
    justify-content: right;
    padding-right: 55px;
}

.ag-header-cell.text-center-align .ag-header-cell-label, .ag-header-group-cell.text-center-align .ag-header-group-cell-label{
    justify-content: center;
    padding-left: unset;
    padding-right: unset;
}

.ag-header-cell.margin-top-40 .ag-header-cell-label{
    margin-top:40px;
}

.ag-header-cell.margin-top-26 .ag-header-cell-label, .ag-header-cell.margin-top-26 .custom-header-label{
    margin-top:26px;
}


.ag-theme-balham .ag-root-wrapper{
    border-radius: 0.25em;
}
.ag-theme-balham .ag-cell, .ag-theme-balham .ag-full-width-row .ag-cell-wrapper.ag-row-group{
    /*line-height: unset;*/
    padding-left: 3px!important;
    padding-right: 3px!important;
}
.ag-theme-balham .ag-header-cell, .ag-theme-balham .ag-header-group-cell{
    padding-left: unset;
    padding-right: unset;
}

.ag-theme-balham .ag-header-cell::after, .ag-theme-balham .ag-header-group-cell::after{
    height:100% !important;
    top:unset!important;
}

.ag-theme-balham:not(#skill-select-view) .ag-center-cols-viewport{
    height: calc(100%)!important;
}
.reactNav #graphView ::-webkit-scrollbar {width: 6px;}


.vertical-align-heading  .ag-cell-label-container {
    /* Necessary to allow for text to grow vertically */
    height: 100%;
}

.vertical-align-heading .ag-header-cell-label {
    /* Necessary to allow for text to grow vertically */
    height: 100%;
    padding: 0 !important;
}

.vertical-align-heading .ag-header-cell-label .ag-header-cell-text {
    /* Force the width corresponding at how much width
    we need once the text is laid out vertically */
    width: 30px;
    transform: rotate(90deg);
    margin-top: -30px;
    overflow: unset;
    /* Since we are rotating a span */
    display: inline-block;
}

.custom-header-cont {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    padding: 8px 0 4px 0;
    margin-left: -6px;
}
.custom-header-cont .material-icons {
    color: var(--on-surface-mid-colour);
}
.rotation-label-vert-wrapper {
    width: 40px;
    padding-top: 12px;
}
.rotation-label-vert {
    transform: rotate(90deg) translate(15%, 50%);
    width: 70px;
    overflow: hidden;
    text-overflow: ellipsis;
}

.custom-cell-cont {
    display: flex;
    padding: 2px 0 0 2px;
    justify-content: space-between;
    color: var(--on-surface-colour);
}
.custom-cell-cont button {
    margin-top: -2px;
    color: var(--on-surface-colour);
}
.custom-cell-cont .label {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.test-result-dialog-blk .js-studentName {
    display: none;
}

.ag-theme-balham .vertical-align-heading .ag-header-cell-label .ag-header-cell-text {
    height: auto;
    overflow: visible;
    overflow-wrap: normal;
    text-overflow: clip;
    white-space: normal;
}

.inlineForm{
    /*margin-top:4px;*/
    /*margin-bottom:4px;*/
    padding-bottom:8px;
}



.inlineForm .ant-form-item-label{
    padding: 0;
    max-width: unset;
}

.tooltipLabel .ant-form-item-label label{
    vertical-align: text-top;
}

.export-toolbar{
    padding:8px;
    justify-content: right;
    flex-wrap: wrap;
    display: flex;
}

.export-toolbar > button > svg{
    vertical-align: sub;
}

.inlineForm:not(.ignoreInlineForm) .ant-form-item{
    display: inline-flex;
    gap:8px;
}

#diagnosticReports .ant-form-item-control{
    margin-left:4px;
}

.inlineForm .ant-form-item.toggleSwitch .ant-form-item-control{
    margin-top:-2px;

}
.ant-form-item.toggleSwitch .ant-form-item-row{
    flex-wrap: nowrap;
}
/*.inlineForm .ant-form-item.toggleSwitch{*/
/*    margin-top:-5px;*/

/*}*/

#classDiagnostic .ant-form-item-label, #contentSearchForm .ant-form-item-label{
    font-weight: bold;
    font-size: 16px;
    white-space:nowrap;
}

#classDiagnostic .ant-row:not(:last-child){
    margin-bottom:4px;
}
#classDiagnostic .ant-row{
    gap:4px;
}

.ag-floating-bottom-container .ag-cell{
    border-right:1px solid lightgrey!important;
}

.content-span-cell {
    background: white;
    /*border-left: 1px solid lightgrey !important;*/
    border-right: 1px solid lightgrey !important;
    border-bottom: 1px solid lightgrey !important;
}

#order-by-aggregate-view .ag-cell[col-id="correctPercent"]{
    line-height:34px;
}

.inlineForm #aggregateFields .ant-form-item{
    /*margin-top:-5px;*/
}

.ag-theme-balham .ag-ltr .ag-has-focus .ag-cell-focus:not(.ag-cell-range-selected), .ag-theme-balham .ag-ltr .ag-context-menu-open .ag-cell-focus:not(.ag-cell-range-selected), .ag-theme-balham .ag-ltr .ag-has-focus .ag-full-width-row.ag-row-focus .ag-cell-wrapper.ag-row-group, .ag-theme-balham .ag-ltr .ag-cell-range-single-cell, .ag-theme-balham .ag-ltr .ag-cell-range-single-cell.ag-cell-range-handle, .ag-theme-balham .ag-rtl .ag-has-focus .ag-cell-focus:not(.ag-cell-range-selected), .ag-theme-balham .ag-rtl .ag-context-menu-open .ag-cell-focus:not(.ag-cell-range-selected), .ag-theme-balham .ag-rtl .ag-has-focus .ag-full-width-row.ag-row-focus .ag-cell-wrapper.ag-row-group, .ag-theme-balham .ag-rtl .ag-cell-range-single-cell, .ag-theme-balham .ag-rtl .ag-cell-range-single-cell.ag-cell-range-handle {
    border: 1px solid;
    border-color: #0091ea !important;
}

.line-chart-legend {
    padding: 12px 0;
}

.line-chart-legend.legend-vertical{
    display: flex;
    flex-direction: column;
    gap: 26px;
    justify-content: center;
    padding: 12px;
}

.line-chart-legend .legend-horizontal{
    display: flex;
    gap: 26px;
    justify-content: center;
    flex-wrap:wrap;
}

.line-chart-legend.legend-vertical .legend-item{
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.line-chart-legend .legend-horizontal .legend-item{
    display: flex;
    /*flex-*/
    /*flex-direction: column;*/
    /*justify-content: center;*/
}
.line-chart-legend .legend-horizontal .legend-item div{
    display: flex;
    /*flex-*/
    /*flex-direction: column;*/
    /*justify-content: center;*/
}

.line-chart-legend .box{
    display: flex;
    justify-content: center;
    width: 50px;
    height: 14px;
    border: 3px solid;
}
.line-chart-legend .circleWrapper > .circle{
    display: flex;
    justify-content: center;
    width: 18px;
    border-radius: 50%;
    height: 18px;
    border: 3px solid;
}
.line-chart-legend .squareWrapper > .square{
    display: flex;
    justify-content: center;
    width: 18px;
    height: 18px;
    border: 3px solid;
}

.line-chart-legend .diamond{
    margin-top:-3px;
    width:25px;
    height:25px;
    clip-path: polygon(50% 10%, 80% 50%, 50% 90%, 20% 50%);
}


.line-chart-legend .dashWrapper{
    display:flex;
}
.line-chart-legend .dash{
    width:18px;
    height:3px;
    margin-top:8px;
}

.line-chart-legend .boxWrapper{
    display: flex;
    justify-content: center;
    margin-bottom: 4px;
}

.line-chart-legend.legend-vertical .boxWrapper .box {
    margin-top: 4px;
}

.line-chart-legend.legend-vertical .text {
    margin-top: -6px;
}

.line-chart-legend .text{
    font-weight: bold;
    font-size: 0.8em;
    color: #606060;
    text-align: center;
    white-space: nowrap;
}

.line-chart-legend .label{
    font-weight: bold;
    color: #606060;
    text-align: center;
    padding-bottom: 8px;
}

/*#diagnosticReports .rc-virtual-list-scrollbar.rc-virtual-list-scrollbar-show {*/
/*    display: block!important;*/
/*}*/

.fixed-ag-header{
    position:fixed!important;
    top:16px;
    z-index:9;
    border-radius: 0.25em 0.25em 0 0;
    border-top:1px solid rgba(var(--on-surface-colour-RGB), .2);
}
.grid-fixed-mask {
    position: fixed !important;
    background: var(--surface-colour);
    top: 0;
    z-index: 8;
    opacity: 0;
    height: 0;
    overflow: hidden;
}
.grid-fixed-mask .top-mask {
    height:16px;
}
.grid-fixed-mask .border-mask {
    height:120px;
    border-radius: 0.25em 0.25em 0 0;
    border-left:1px solid rgba(var(--on-surface-colour-RGB), .2);
    border-right:1px solid rgba(var(--on-surface-colour-RGB), .2);
}
.grid-fixed-mask.show {
    opacity: 1;
    height: auto;
}

.ag-pinned-right-header .fixed-ag-header-right{
    position:fixed!important;
    top:8px;
    right:39px;
    z-index:9;
    background:#F5F7F7;
}
.ag-pinned-right-header .fixed-ag-header-right .ag-header-cell:first-child{
    border-left:1px solid #D9DDDF;
}

.ag-pinned-right-header .fixed-ag-header-right .ag-header-cell:last-child{
    border-right:1px solid #D9DDDF;
}

.testSelectionTable tbody tr{
    cursor: pointer;
}

.table-report-disabled-row{
    opacity:0.5;
    cursor: not-allowed;
    pointer-events: none;
    background: #f3f3f3;
}

#teacherDiagnostics .ant-tabs-tabpane{
    width:98%;
}

.ag-grid-wrapper .bold-header-group{
    font-weight: bold;
}

.ag-grid-wrapper .question-centered-header {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
}

.ag-grid-wrapper .question-centered-header .ag-cell-label-container {
    width:unset;
}

.ag-theme-balham .question-centered-header.ag-header-cell{
    padding-left: 2px;
    padding-right: 2px;
}

.left-26 .ag-header-cell-label{
    left:26px!important;
}

.performance-table {
    width: 100%;
    border: none;
    margin-top: 30px;
}

.performance-chapter-row:not(:first-of-type) td {
    padding-top: 6px;
}

.performance-concept-row td {
    padding: 6px 0;
}

.performance-skill-row.pre td {
    padding-top: 15px;
}

.performance-skill-row.post td {
    padding-bottom: 15px;
}

.performance-skill-row td:last-child {
    padding-right: 4px;
}

.performance-table td.skill-name {
    vertical-align: top;
    width: 18%
}

.skill-name div {
    padding: 6px;
}

.performance-holder {
    display: flex;
    align-items: center;
}

.performance-bar {
    display: flex;
    width: 100%;
    height: 30px;
    margin: 2px 0;
    background: #FAFAFA;
    cursor: pointer;
}
.performance-bar.no-results {
    cursor: default;
}

.performance-bar.results:hover {
    box-shadow: 1px 2px 5px 1px var(--box-shadow-colour);
}

.performance-label {
    font-size: 12px;
    width: 88px;
}

.performance-bar .performance {
    height: 100%;
    text-align: right;
    font-weight: bold;
    border-radius: 2px;
}

.performance-bar .pre.performance {
    background: #2883EA;
}
.performance-bar .post.performance {
    background: #EBE1FE;
}

.performance {
    display: flex;
    align-items: center;
}

.performance .label {
    margin-left: auto;
    margin-right: 8px;
}

.average-marker {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    width: 0;
}

.average-marker .label {
    color: #888;
    position: relative;
    top: -6px;
    text-align: center;
}

.average-marker.pre .label {
    top: -57px;
}

.performance-marker {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    width: 0;
    top: 4px;
}

.performance-marker .background {
    padding: 0 4px;
    background: rgba(255, 255, 255, .6);
    border-radius: 2px;
    transform: translateX(-60%);
}

.performance-marker.pre .label {
    color: #2883EA;
}

.performance-marker.post .label {
    color: #C471FB;
}

.performance-divider td {
    border-bottom: 1px solid #D3D3D3;
    padding-top: 14px;
}

.performance-divider + .performance-student-row td {
    padding-top: 14px;
}

.performance-student-label {
    font-size: 1.2em;
    font-weight: bold;
}

.inlineForm .ant-row{
    flex-wrap: nowrap;
}
.inlineForm .ant-form-item-row{
    white-space: nowrap;
}

.custom-y-axis-line .recharts-cartesian-axis-line{
    display:none;
}

.growth-vs-attainment-view .recharts-xAxis .recharts-cartesian-axis-ticks {
    transform: translate(0, -41.5%);
}

.data-set-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.data-set-header .export-toolbar {
    padding: 8px 4px;
}

.comparison-view .graph, .growth-vs-attainment-view .graph, .score-vs-time-view .graph {
    margin-top: 16px;
}

.ag-theme-balham .unset-whitespace .ag-header-cell-text{
    word-break:unset!important;
}
`, "",{"version":3,"sources":["webpack://./src/main/ui/diagnosticReporting/DiagnosticStyles.css"],"names":[],"mappings":";AACA;IACI,YAAY;AAChB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;;AAGA;IACI,qBAAqB;AACzB;AACA;IACI,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;AAChC;AACA;IACI,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,4BAA4B;AAChC;AACA,0CAA0C,UAAU,CAAC;;;AAGrD;IACI,mDAAmD;IACnD,YAAY;AAChB;;AAEA;IACI,mDAAmD;IACnD,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI;kDAC8C;IAC9C,WAAW;IACX,wBAAwB;IACxB,iBAAiB;IACjB,eAAe;IACf,iCAAiC;IACjC,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,YAAY;IACZ,oBAAoB;IACpB,iBAAiB;AACrB;AACA;IACI,mCAAmC;AACvC;AACA;IACI,WAAW;IACX,iBAAiB;AACrB;AACA;IACI,4CAA4C;IAC5C,WAAW;IACX,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,8BAA8B;IAC9B,+BAA+B;AACnC;AACA;IACI,gBAAgB;IAChB,+BAA+B;AACnC;AACA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,qBAAqB;IACrB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;AACtB;;;;AAIA;IACI,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,OAAO;AACX;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;;AAEnB;AACA;IACI,iBAAiB;AACrB;AACA,2CAA2C;AAC3C,uBAAuB;;AAEvB,IAAI;;AAEJ;IACI,iBAAiB;IACjB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;AACA;IACI,OAAO;AACX;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,iBAAiB;IACjB,+CAA+C;IAC/C,4CAA4C;IAC5C,6CAA6C;AACjD;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,0BAA0B;IAC1B,2BAA2B;AAC/B;AACA;IACI,aAAa;IACb,QAAQ;IACR,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,UAAU;IACV,WAAW;IACX,sDAAsD;AAC1D;;;AAGA;IACI,YAAY;AAChB;AACA;IACI,UAAU;IACV,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA,iFAAiF;AACjF,gCAAgC;AAChC,IAAI;;AAEJ;IACI,wBAAwB;IACxB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,2DAA2D;AAC/D;AACA;IACI,0BAA0B;IAC1B,iCAAiC;IACjC,MAAM;IACN,UAAU;IACV,UAAU;IACV,SAAS;IACT,gBAAgB;AACpB;AACA;IACI,WAAW;AACf;AACA;IACI,YAAY;IACZ,gCAAgC;IAChC,4DAA4D;IAC5D,6DAA6D;AACjE;AACA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,wBAAwB;IACxB,OAAO;IACP,UAAU;IACV,SAAS;IACT,kBAAkB;AACtB;AACA;IACI,6BAA6B;AACjC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,eAAe;AACnB;;AAEA;IACI,oDAAoD;AACxD;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,mCAAmC;IACnC,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gCAAgC;IAChC,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B","sourcesContent":["\n#questionResultDialog .question-result-content{\n    padding:16px;\n}\n.text-bold{\n    font-weight: bold;\n}\n.pre-test-group{\n    background-color:#ffddbc;\n}\n.post-test-group{\n    background-color:#f5ffbc;\n}\n\n#order-by-aggregate-view .ag-ltr .ag-cell.user-cell{\n    line-height:32px;\n}\n\n.ag-header-cell.text-right-align .ag-header-cell-label, .ag-header-group-cell.text-right-align .ag-header-group-cell-label {\n    justify-content: right;\n    padding-right: 55px;\n}\n\n.ag-header-cell.text-center-align .ag-header-cell-label, .ag-header-group-cell.text-center-align .ag-header-group-cell-label{\n    justify-content: center;\n    padding-left: unset;\n    padding-right: unset;\n}\n\n.ag-header-cell.margin-top-40 .ag-header-cell-label{\n    margin-top:40px;\n}\n\n.ag-header-cell.margin-top-26 .ag-header-cell-label, .ag-header-cell.margin-top-26 .custom-header-label{\n    margin-top:26px;\n}\n\n\n.ag-theme-balham .ag-root-wrapper{\n    border-radius: 0.25em;\n}\n.ag-theme-balham .ag-cell, .ag-theme-balham .ag-full-width-row .ag-cell-wrapper.ag-row-group{\n    /*line-height: unset;*/\n    padding-left: 3px!important;\n    padding-right: 3px!important;\n}\n.ag-theme-balham .ag-header-cell, .ag-theme-balham .ag-header-group-cell{\n    padding-left: unset;\n    padding-right: unset;\n}\n\n.ag-theme-balham .ag-header-cell::after, .ag-theme-balham .ag-header-group-cell::after{\n    height:100% !important;\n    top:unset!important;\n}\n\n.ag-theme-balham:not(#skill-select-view) .ag-center-cols-viewport{\n    height: calc(100%)!important;\n}\n.reactNav #graphView ::-webkit-scrollbar {width: 6px;}\n\n\n.vertical-align-heading  .ag-cell-label-container {\n    /* Necessary to allow for text to grow vertically */\n    height: 100%;\n}\n\n.vertical-align-heading .ag-header-cell-label {\n    /* Necessary to allow for text to grow vertically */\n    height: 100%;\n    padding: 0 !important;\n}\n\n.vertical-align-heading .ag-header-cell-label .ag-header-cell-text {\n    /* Force the width corresponding at how much width\n    we need once the text is laid out vertically */\n    width: 30px;\n    transform: rotate(90deg);\n    margin-top: -30px;\n    overflow: unset;\n    /* Since we are rotating a span */\n    display: inline-block;\n}\n\n.custom-header-cont {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    height: 100%;\n    padding: 8px 0 4px 0;\n    margin-left: -6px;\n}\n.custom-header-cont .material-icons {\n    color: var(--on-surface-mid-colour);\n}\n.rotation-label-vert-wrapper {\n    width: 40px;\n    padding-top: 12px;\n}\n.rotation-label-vert {\n    transform: rotate(90deg) translate(15%, 50%);\n    width: 70px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.custom-cell-cont {\n    display: flex;\n    padding: 2px 0 0 2px;\n    justify-content: space-between;\n    color: var(--on-surface-colour);\n}\n.custom-cell-cont button {\n    margin-top: -2px;\n    color: var(--on-surface-colour);\n}\n.custom-cell-cont .label {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.test-result-dialog-blk .js-studentName {\n    display: none;\n}\n\n.ag-theme-balham .vertical-align-heading .ag-header-cell-label .ag-header-cell-text {\n    height: auto;\n    overflow: visible;\n    overflow-wrap: normal;\n    text-overflow: clip;\n    white-space: normal;\n}\n\n.inlineForm{\n    /*margin-top:4px;*/\n    /*margin-bottom:4px;*/\n    padding-bottom:8px;\n}\n\n\n\n.inlineForm .ant-form-item-label{\n    padding: 0;\n    max-width: unset;\n}\n\n.tooltipLabel .ant-form-item-label label{\n    vertical-align: text-top;\n}\n\n.export-toolbar{\n    padding:8px;\n    justify-content: right;\n    flex-wrap: wrap;\n    display: flex;\n}\n\n.export-toolbar > button > svg{\n    vertical-align: sub;\n}\n\n.inlineForm:not(.ignoreInlineForm) .ant-form-item{\n    display: inline-flex;\n    gap:8px;\n}\n\n#diagnosticReports .ant-form-item-control{\n    margin-left:4px;\n}\n\n.inlineForm .ant-form-item.toggleSwitch .ant-form-item-control{\n    margin-top:-2px;\n\n}\n.ant-form-item.toggleSwitch .ant-form-item-row{\n    flex-wrap: nowrap;\n}\n/*.inlineForm .ant-form-item.toggleSwitch{*/\n/*    margin-top:-5px;*/\n\n/*}*/\n\n#classDiagnostic .ant-form-item-label, #contentSearchForm .ant-form-item-label{\n    font-weight: bold;\n    font-size: 16px;\n    white-space:nowrap;\n}\n\n#classDiagnostic .ant-row:not(:last-child){\n    margin-bottom:4px;\n}\n#classDiagnostic .ant-row{\n    gap:4px;\n}\n\n.ag-floating-bottom-container .ag-cell{\n    border-right:1px solid lightgrey!important;\n}\n\n.content-span-cell {\n    background: white;\n    /*border-left: 1px solid lightgrey !important;*/\n    border-right: 1px solid lightgrey !important;\n    border-bottom: 1px solid lightgrey !important;\n}\n\n#order-by-aggregate-view .ag-cell[col-id=\"correctPercent\"]{\n    line-height:34px;\n}\n\n.inlineForm #aggregateFields .ant-form-item{\n    /*margin-top:-5px;*/\n}\n\n.ag-theme-balham .ag-ltr .ag-has-focus .ag-cell-focus:not(.ag-cell-range-selected), .ag-theme-balham .ag-ltr .ag-context-menu-open .ag-cell-focus:not(.ag-cell-range-selected), .ag-theme-balham .ag-ltr .ag-has-focus .ag-full-width-row.ag-row-focus .ag-cell-wrapper.ag-row-group, .ag-theme-balham .ag-ltr .ag-cell-range-single-cell, .ag-theme-balham .ag-ltr .ag-cell-range-single-cell.ag-cell-range-handle, .ag-theme-balham .ag-rtl .ag-has-focus .ag-cell-focus:not(.ag-cell-range-selected), .ag-theme-balham .ag-rtl .ag-context-menu-open .ag-cell-focus:not(.ag-cell-range-selected), .ag-theme-balham .ag-rtl .ag-has-focus .ag-full-width-row.ag-row-focus .ag-cell-wrapper.ag-row-group, .ag-theme-balham .ag-rtl .ag-cell-range-single-cell, .ag-theme-balham .ag-rtl .ag-cell-range-single-cell.ag-cell-range-handle {\n    border: 1px solid;\n    border-color: #0091ea !important;\n}\n\n.line-chart-legend {\n    padding: 12px 0;\n}\n\n.line-chart-legend.legend-vertical{\n    display: flex;\n    flex-direction: column;\n    gap: 26px;\n    justify-content: center;\n    padding: 12px;\n}\n\n.line-chart-legend .legend-horizontal{\n    display: flex;\n    gap: 26px;\n    justify-content: center;\n    flex-wrap:wrap;\n}\n\n.line-chart-legend.legend-vertical .legend-item{\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n}\n\n.line-chart-legend .legend-horizontal .legend-item{\n    display: flex;\n    /*flex-*/\n    /*flex-direction: column;*/\n    /*justify-content: center;*/\n}\n.line-chart-legend .legend-horizontal .legend-item div{\n    display: flex;\n    /*flex-*/\n    /*flex-direction: column;*/\n    /*justify-content: center;*/\n}\n\n.line-chart-legend .box{\n    display: flex;\n    justify-content: center;\n    width: 50px;\n    height: 14px;\n    border: 3px solid;\n}\n.line-chart-legend .circleWrapper > .circle{\n    display: flex;\n    justify-content: center;\n    width: 18px;\n    border-radius: 50%;\n    height: 18px;\n    border: 3px solid;\n}\n.line-chart-legend .squareWrapper > .square{\n    display: flex;\n    justify-content: center;\n    width: 18px;\n    height: 18px;\n    border: 3px solid;\n}\n\n.line-chart-legend .diamond{\n    margin-top:-3px;\n    width:25px;\n    height:25px;\n    clip-path: polygon(50% 10%, 80% 50%, 50% 90%, 20% 50%);\n}\n\n\n.line-chart-legend .dashWrapper{\n    display:flex;\n}\n.line-chart-legend .dash{\n    width:18px;\n    height:3px;\n    margin-top:8px;\n}\n\n.line-chart-legend .boxWrapper{\n    display: flex;\n    justify-content: center;\n    margin-bottom: 4px;\n}\n\n.line-chart-legend.legend-vertical .boxWrapper .box {\n    margin-top: 4px;\n}\n\n.line-chart-legend.legend-vertical .text {\n    margin-top: -6px;\n}\n\n.line-chart-legend .text{\n    font-weight: bold;\n    font-size: 0.8em;\n    color: #606060;\n    text-align: center;\n    white-space: nowrap;\n}\n\n.line-chart-legend .label{\n    font-weight: bold;\n    color: #606060;\n    text-align: center;\n    padding-bottom: 8px;\n}\n\n/*#diagnosticReports .rc-virtual-list-scrollbar.rc-virtual-list-scrollbar-show {*/\n/*    display: block!important;*/\n/*}*/\n\n.fixed-ag-header{\n    position:fixed!important;\n    top:16px;\n    z-index:9;\n    border-radius: 0.25em 0.25em 0 0;\n    border-top:1px solid rgba(var(--on-surface-colour-RGB), .2);\n}\n.grid-fixed-mask {\n    position: fixed !important;\n    background: var(--surface-colour);\n    top: 0;\n    z-index: 8;\n    opacity: 0;\n    height: 0;\n    overflow: hidden;\n}\n.grid-fixed-mask .top-mask {\n    height:16px;\n}\n.grid-fixed-mask .border-mask {\n    height:120px;\n    border-radius: 0.25em 0.25em 0 0;\n    border-left:1px solid rgba(var(--on-surface-colour-RGB), .2);\n    border-right:1px solid rgba(var(--on-surface-colour-RGB), .2);\n}\n.grid-fixed-mask.show {\n    opacity: 1;\n    height: auto;\n}\n\n.ag-pinned-right-header .fixed-ag-header-right{\n    position:fixed!important;\n    top:8px;\n    right:39px;\n    z-index:9;\n    background:#F5F7F7;\n}\n.ag-pinned-right-header .fixed-ag-header-right .ag-header-cell:first-child{\n    border-left:1px solid #D9DDDF;\n}\n\n.ag-pinned-right-header .fixed-ag-header-right .ag-header-cell:last-child{\n    border-right:1px solid #D9DDDF;\n}\n\n.testSelectionTable tbody tr{\n    cursor: pointer;\n}\n\n.table-report-disabled-row{\n    opacity:0.5;\n    cursor: not-allowed;\n    pointer-events: none;\n    background: #f3f3f3;\n}\n\n#teacherDiagnostics .ant-tabs-tabpane{\n    width:98%;\n}\n\n.ag-grid-wrapper .bold-header-group{\n    font-weight: bold;\n}\n\n.ag-grid-wrapper .question-centered-header {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n}\n\n.ag-grid-wrapper .question-centered-header .ag-cell-label-container {\n    width:unset;\n}\n\n.ag-theme-balham .question-centered-header.ag-header-cell{\n    padding-left: 2px;\n    padding-right: 2px;\n}\n\n.left-26 .ag-header-cell-label{\n    left:26px!important;\n}\n\n.performance-table {\n    width: 100%;\n    border: none;\n    margin-top: 30px;\n}\n\n.performance-chapter-row:not(:first-of-type) td {\n    padding-top: 6px;\n}\n\n.performance-concept-row td {\n    padding: 6px 0;\n}\n\n.performance-skill-row.pre td {\n    padding-top: 15px;\n}\n\n.performance-skill-row.post td {\n    padding-bottom: 15px;\n}\n\n.performance-skill-row td:last-child {\n    padding-right: 4px;\n}\n\n.performance-table td.skill-name {\n    vertical-align: top;\n    width: 18%\n}\n\n.skill-name div {\n    padding: 6px;\n}\n\n.performance-holder {\n    display: flex;\n    align-items: center;\n}\n\n.performance-bar {\n    display: flex;\n    width: 100%;\n    height: 30px;\n    margin: 2px 0;\n    background: #FAFAFA;\n    cursor: pointer;\n}\n.performance-bar.no-results {\n    cursor: default;\n}\n\n.performance-bar.results:hover {\n    box-shadow: 1px 2px 5px 1px var(--box-shadow-colour);\n}\n\n.performance-label {\n    font-size: 12px;\n    width: 88px;\n}\n\n.performance-bar .performance {\n    height: 100%;\n    text-align: right;\n    font-weight: bold;\n    border-radius: 2px;\n}\n\n.performance-bar .pre.performance {\n    background: #2883EA;\n}\n.performance-bar .post.performance {\n    background: #EBE1FE;\n}\n\n.performance {\n    display: flex;\n    align-items: center;\n}\n\n.performance .label {\n    margin-left: auto;\n    margin-right: 8px;\n}\n\n.average-marker {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    position: relative;\n    width: 0;\n}\n\n.average-marker .label {\n    color: #888;\n    position: relative;\n    top: -6px;\n    text-align: center;\n}\n\n.average-marker.pre .label {\n    top: -57px;\n}\n\n.performance-marker {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    position: relative;\n    width: 0;\n    top: 4px;\n}\n\n.performance-marker .background {\n    padding: 0 4px;\n    background: rgba(255, 255, 255, .6);\n    border-radius: 2px;\n    transform: translateX(-60%);\n}\n\n.performance-marker.pre .label {\n    color: #2883EA;\n}\n\n.performance-marker.post .label {\n    color: #C471FB;\n}\n\n.performance-divider td {\n    border-bottom: 1px solid #D3D3D3;\n    padding-top: 14px;\n}\n\n.performance-divider + .performance-student-row td {\n    padding-top: 14px;\n}\n\n.performance-student-label {\n    font-size: 1.2em;\n    font-weight: bold;\n}\n\n.inlineForm .ant-row{\n    flex-wrap: nowrap;\n}\n.inlineForm .ant-form-item-row{\n    white-space: nowrap;\n}\n\n.custom-y-axis-line .recharts-cartesian-axis-line{\n    display:none;\n}\n\n.growth-vs-attainment-view .recharts-xAxis .recharts-cartesian-axis-ticks {\n    transform: translate(0, -41.5%);\n}\n\n.data-set-header {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.data-set-header .export-toolbar {\n    padding: 8px 4px;\n}\n\n.comparison-view .graph, .growth-vs-attainment-view .graph, .score-vs-time-view .graph {\n    margin-top: 16px;\n}\n\n.ag-theme-balham .unset-whitespace .ag-header-cell-text{\n    word-break:unset!important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
